import React from 'react';
import { useIntl } from 'react-intl';

import Paper from '@mui/material/Paper';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

const subTabs = [
  {
    title: {
      id: 'configurations.company.paymentProviders.detailsModal.tabs.generalInfo',
      defaultMessage: 'General Information',
    },
  },
  {
    title: {
      id: 'configurations.company.paymentProviders.detailsModal.tabs.accountList',
      defaultMessage: 'Account List',
    },
  },
  {
    title: {
      id: 'configurations.company.paymentProviders.detailsModal.tabs.approvalFlow',
      defaultMessage: 'Approval Flow',
    },
  },
  {
    title: {
      id: 'configurations.company.paymentProviders.detailsModal.tabs.userRoles',
      defaultMessage: 'User Roles',
    },
  },
];

interface DetailsSubTabProps {
  selected: number;
  handleClick?: (index: number) => void;
  handleTabChange: (event: React.SyntheticEvent, newIndex: number) => void;
}

const DetailsSubTab: React.FC<DetailsSubTabProps> = ({ selected, handleTabChange }) => {
  const { formatMessage } = useIntl();

  return (
    <Paper
      variant="outlined"
      sx={{
        width: 270,
        border: 1,
        mr: 5,
        p: 1,
        pr: 0,
        borderColor: 'grey.200',
        height: 'fit-content',
        alignItems: 'start',
      }}
    >
      <Tabs value={selected} onChange={handleTabChange} orientation="vertical">
        {subTabs.map(({ title }) => (
          <Tab
            key={title.id}
            sx={{
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
            }}
            label={formatMessage(title)}
          />
        ))}
      </Tabs>
    </Paper>
  );
};

export default DetailsSubTab;
